import { gql } from '@apollo/client'
import employeeTagInfoFragment from '../ranking/fragments/employeeTagInfoFragment'
import contractChangeFragment from './fragments/contractChange.fragment'
import contractChangeValidationListFragment from './fragments/contractChangeValidationList.fragment'
import latestContractFragment from './fragments/latestContract.fragment'
import salaryOfYearFragment from './fragments/salaryOfYearFragment'
import targetBonusOfYearFragment from './fragments/targetBonusOfYear.fragment'
import contractValidityInYearFragment from './fragments/contractValidityInYear.fragment'

export const CurrentContractGql = gql`
  query CurrentContract($employeeId: HashedId!) {
    currentContract(employeeId: $employeeId) {
      ...LatestContractDTO
    }
    branchOfficeByEmployee(employeeId: $employeeId) {
      timezone
    }
  }
  ${latestContractFragment}
`

export const GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION = gql`
  query currentContractWithCareerPathEvaluation(
    $employeeId: HashedId!
    $year: Int!
    $withChanges: Boolean!
    $includeAllTargetBoni: Boolean!
    $country: Country!
  ) {
    targetBonusOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...TargetBonusOfYear
    }
    contractChangesByEmployee(employeeId: $employeeId) @include(if: $withChanges) {
      ...ContractChange
    }
    isBonusValidationEnabled(country: $country)
    currentContract(employeeId: $employeeId) @include(if: $withChanges) {
      ...LatestContractDTO
    }
    salaryOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...SalaryOfYear
    }
    contractsInYear(employeeId: $employeeId, year: $year) {
      ...ContractValidityInYear
    }
    careerPathEvaluation(employeeId: $employeeId) {
      salaryEvaluation
      bonusEvaluation
      summary
      salary
      targetBonus
    }
    careerPath(country: $country) {
      careerPathType
      country
      level
      min
      max
    }
    branchOfficeByEmployee(employeeId: $employeeId) {
      code
      name
      timezone
      addressId
    }
  }
  ${targetBonusOfYearFragment}
  ${contractChangeFragment}
  ${latestContractFragment}
  ${salaryOfYearFragment}
  ${contractValidityInYearFragment}
`

export const GET_CURRENT_CONTRACT_WITH_CAREER_PATH_EVALUATION_IN_PROFILE = gql`
  query currentContractWithCareerPathEvaluationInProfile(
    $employeeId: HashedId!
    $year: Int!
    $includeAllTargetBoni: Boolean!
    $country: Country!
  ) {
    targetBonusOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAllTargetBoni) {
      ...TargetBonusOfYear
    }
    currentContract(employeeId: $employeeId) {
      ...LatestContractDTO
    }
    careerPathEvaluation(employeeId: $employeeId) {
      salaryEvaluation
      bonusEvaluation
      summary
      salary
      targetBonus
    }
    careerPath(country: $country) {
      careerPathType
      country
      level
      min
      max
    }
  }
  ${targetBonusOfYearFragment}
  ${latestContractFragment}
`

export const RESIGNED_EMPLOYEE_OVERVIEW_TAB_DATA = gql`
  query resignedEmployeeOverviewTabData($employeeId: HashedId!, $types: [EmployeeTagType!], $country: Country!) {
    resignedContract(employeeId: $employeeId) {
      ...LatestContractDTO
    }
    resignedEmployeeCareerPathEvaluation(employeeId: $employeeId) {
      salaryEvaluation
      bonusEvaluation
      summary
      salary
      targetBonus
    }
    careerPath(country: $country) {
      careerPathType
      country
      level
      min
      max
    }
    tagHistoryOfResignedEmployeeUntilReplyEntryDate(employeeId: $employeeId, types: $types) {
      ...EmployeeTagInfo
    }
  }
  ${latestContractFragment}
  ${employeeTagInfoFragment}
`

export const TargetBonusOfYear = gql`
  query TargetBonusOfYear($employeeId: HashedId!, $year: Int!, $includeAll: Boolean) {
    targetBonusOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAll) {
      ...TargetBonusOfYear
    }
  }
  ${targetBonusOfYearFragment}
`

export const ContractChanges = gql`
  query ContractChanges($employeeId: HashedId!) {
    contractChangesByEmployee(employeeId: $employeeId) {
      ...ContractChange
    }
  }
  ${contractChangeFragment}
`

export const TargetBonusAndContractChange = gql`
  query TargetBonusAndContractChange($employeeId: HashedId!, $year: Int!, $includeAll: Boolean) {
    targetBonusOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAll) {
      ...TargetBonusOfYear
    }
    salaryOfYear(employeeId: $employeeId, year: $year, includeAll: $includeAll) {
      ...SalaryOfYear
    }
    contractChangesByEmployee(employeeId: $employeeId) {
      ...ContractChange
    }
  }
  ${targetBonusOfYearFragment}
  ${contractChangeFragment}
  ${salaryOfYearFragment}
`

export const CONTRACT_CHANGE_VALIDATION_LIST = gql`
  query contractChangeValidationList($employeeId: HashedId!, $country: Country!) {
    contractChangeValidationList(employeeId: $employeeId) {
      ...ContractChangeValidationList
    }
    isEmployeeLevelValidationEnabled(country: $country)
    employeeLevels: getCountryEmployeeLevels(country: $country)
  }
  ${contractChangeValidationListFragment}
`

export default {
  CurrentContractGql,
  TargetBonusOfYear,
  ContractChanges,
  TargetBonusAndContractChange,
}
